import { State } from '../../../store/state';

export const reclassifySelector = (state: State) => state.reclassify;
export const reclassifySelectedArticlesSelector = (state: State) => state.reclassify.selectedArticles;
export const reclassifyOperationLoadingSelector = (state: State) => state.reclassify.reclassifyLoading;
export const reclassifyErrorSelector = (state: State) => state.reclassify.error;
export const reclassifyLastResultSelector = (state: State) => state.reclassify.lastReclassifyResult;

// Nuevos selectores para artículos
export const reclassifyArticlesSelector = (state: State) => state.reclassify.articles;
export const reclassifyArticlesLoadingSelector = (state: State) => state.reclassify.articlesLoading;
export const reclassifyPaginationSelector = (state: State) => state.reclassify.pagination;
export const reclassifyFiltersSelector = (state: State) => state.reclassify.filters; 